import { EVENTS } from '@archetype-themes/utils/events';

let selectors = {
  search: 'toggle-search',
};

class ToggleSearch extends HTMLElement {
  connectedCallback() {
    this.abortController = new AbortController();
    this.isOpen = false;

    // Trigger to open header search
    this.trigger = this.querySelector(`[href="${window.Shopify.routes.root}search"]`);

    if (!this.trigger) {
      console.error('Search trigger not found.');
      return;
    }

    // Open header search
    this.trigger.addEventListener('click', this.handleClick.bind(this), { signal: this.abortController.signal });

    // Close header search
    document.addEventListener(EVENTS.predictiveSearchCloseAll, this.handleSearchCloseAll.bind(this), {
      signal: this.abortController.signal,
    });
  }

  handleClick(evt) {
    evt.preventDefault();

    console.log('handleClick triggered, isOpen before toggle:', this.isOpen);

    // Toggle the open state
    this.isOpen = !this.isOpen;

    // Notify other components to close the mobile nav
    evt.target.dispatchEvent(new CustomEvent(EVENTS.mobileNavClose, { bubbles: true }));

    if (this.isOpen) {
      console.log('Opening search...');

      let cartTrigger = document.querySelector(`[href="${window.Shopify.routes.root}cart"]`);
      this.dispatchEvent(new CustomEvent(EVENTS.cartClose, { bubbles: true }));

      if (cartTrigger) {
        cartTrigger.setAttribute('aria-expanded', 'false');
      }

      // Dispatch event to open the search
      this.dispatchEvent(new CustomEvent(EVENTS.headerSearchOpen, { bubbles: true }));

      // Notify ToggleMenu to close
      document.dispatchEvent(new CustomEvent('close-toggle-menu'));
    } else {
      console.log('Closing search...');

      // Dispatch event to close the search
      this.dispatchEvent(new CustomEvent(EVENTS.predictiveSearchCloseAll, { bubbles: true }));
    }

    // Update aria-expanded attribute
    this.trigger.setAttribute('aria-expanded', this.isOpen ? 'true' : 'false');
    console.log('isOpen after toggle:', this.isOpen);
  }

  handleSearchCloseAll() {
    if (!this.isOpen) return; // Avoid unnecessary state changes

    console.log('Search close event triggered.');
    this.isOpen = false;
    this.trigger.setAttribute('aria-expanded', 'false');
  }

  disconnectedCallback() {
    this.abortController.abort(); // Remove event listeners on disconnect
  }
}

customElements.define('toggle-search', ToggleSearch);
